import React, {Component} from 'react'

class NoResults extends Component {
    render() {
        return (
            <h2 style={{color: 'red'}}>No Records Found</h2>
        )
    }
}

export default NoResults



/** WEBPACK FOOTER **
 ** ./src/components/common/NoResults.js
 **/